export const PRIVACY_I18N_ENTRIES = {
  privacy_Data1: {
    es: '<p>Política de privacidad</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data2: {
    es: '<p>Volver</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data3: {
    es: '<p>Fecha de entrada en vigor: %X%</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data4: {
    es: '<p>Bienvenido a SmartMakings. La web SmartMakings (smartmakings.com) es propiedad de la empresa SmartMakings, S.L. (en adelante SmartMakings). En SmartMakings valoramos su privacidad y nos comprometemos a proteger sus datos personales. Esta Política de Privacidad describe cómo recopilamos, utilizamos y protegemos la información que proporcionas cuando visita nuestro sitio web y utilizas nuestros servicios educativos (en adelante el Servicio). Puedes acceder en cualquier momento a la Política de Privacidad a través de la web o la App.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data5: {
    es: '<p>Responsable del tratamiento de tus Datos personales:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data6: {
    es: '<p>Smartmakings, S.L. es responsable del tratamiento de tus datos. Puedes solicitar que te facilitemos los datos esenciales a través de la dirección de correo electrónico: info@smartmakings.com.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data7: {
    es: '<p>Ley aplicable</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data8: {
    es: '<p>Esta Política de Privacidad está adaptada a la normativa española y europea vigente en materia de protección de datos personales en internet siguiendo lo especificado en:<br>·&emsp;&emsp;Reglamento (UE) 2016 / 679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos (RGPD).<br>·&emsp;&emsp;Ley Orgánica 3 / 2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales (LOPD - GDD).<br>·&emsp;&emsp;Real Decreto 1720 / 2007, de 21 de diciembre, por el que se aprueba el Reglamento de desarrollo de la Ley Orgánica 15 / 1999, de 13 de diciembre, de Protección de Datos de Carácter Personal (RDLOPD).<br>·&emsp;&emsp;Ley 34 / 2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI - CE).</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data9: {
    es: '<p>Información que recopilamos:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data10: {
    es: '<p>Ten en cuenta que, para que puedas disfrutar del servicio que te ofrecemos en SmartMakings, utilizaremos algunos datos sobre ti:<br>a. Información de contacto: Recopilamos tu nombre y apellidos, dirección de correo electrónico, número de teléfono, edad, dirección postal cuando te registras en nuestro sitio web o te comunicas con nosotros.<br>b. Información técnica: Podemos recopilar información técnica sobre su dispositivo, como la dirección IP, el tipo de navegador, el sistema operativo y la ubicación geográfica aproximada.<br>c. Información de uso: Registramos su actividad en nuestro sitio web, incluyendo las páginas que visita, las acciones que realiza y el tiempo que pasa en nuestro sitio.<br>d. Información de redes sociales: Recopilamos información de diferentes redes sociales siempre que previamente lo hayas autorizado sus términos y condiciones.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data11: {
    es: '<p>Uso de la información:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data12: {
    es: '<p>a. Prestarte nuestro Servicio<br>b. Enviar noticias y promociones de SmartMakings y terceros basados en tu perfil. Solo lo haremos cuando tú nos autorices.<br>c. Personalización de la experiencia del usuario: Utilizamos la información que recopilamos para personalizar su experiencia en nuestro sitio web y mejorar nuestros servicios.<br>d. Procesamiento de pagos: Utilizamos la información de pago para procesar sus transacciones, garantizar la seguridad de las mismas y luchar contra el fraude.<br>e. Comunicarnos contigo: Podemos utilizar tu información de contacto para enviarte actualizaciones sobre nuestros servicios, responder a tus consultas y proporcionar asistencia al cliente.<br>f. Análisis y mejora: Utilizamos la información técnica y de uso para analizar el rendimiento de nuestro sitio web y mejorar nuestros servicios.<br>g. Usuarios de clientes de empresa: En aquellos casos que hagas uso del Servicio a través de una cuenta que tu empresa tenga con SmartMakings compartiremos datos con tu empleador.<br>h. Cualquier otra cuestión relacionada con la prestación del Servicio</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data13: {
    es: '<p>Protección de datos:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data14: {
    es: '<p>a. Seguridad: Implementamos medidas de seguridad adecuadas para proteger su información contra accesos no autorizados, pérdidas o modificaciones. Llevamos a cabo todas las medidas técnicas y organizativas necesarias para evitar la destrucción, pérdida o alteración accidental o lícita de tus datos. SmartMakings no puede garantizar la inexpugnabilidad de su sistema. En caso de acceso fraudulento a sus datos será comunicado sin dilación acerca del estado de sus datos. Se entiende por violación de la seguridad de los datos personales toda violación de la seguridad que ocasione la destrucción, pérdida o alteración accidental o ilícita de datos personales transmitidos, conservados o tratados de otra forma, o la comunicación o acceso no autorizados a dichos datos.<br>b. Confidencialidad: Los datos personales serán tratados como confidenciales por el Responsable del tratamiento.SmartMakings garantiza que la confidencialidad de sus datos es respetada por sus empleados y asociados.<br>c. Retención de datos: Conservamos tu información personal durante el tiempo necesario para cumplir con nuestros fines comerciales y legales o hasta que solicites la cancelación de tus datos personales.Puedes solicitar el acceso, rectificación, supresión o portabilidad de tus datos personales.<br>d. Terceros: No compartimos su información personal con terceros sin su consentimiento, excepto cuando sea necesario para proporcionarle nuestros servicios o cumplir con obligaciones legales.Esto incluye a:<br>- Proveedores externos en diferentes cuestiones relacionadas con el servicio.<br>- Autoridades u organismos públicos.<br>e. Entidades que realizan estudios de mercado: La Empresa podrá compartir los datos con entidades que realicen estudios estadísticos y de mercado.Todos los datos que se compartan en caso de que SmartMakings contrate la realización de estos estudios serán anónimos.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data15: {
    es: '<p>Cookies y tecnologías similares:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data16: {
    es: '<p>a. Utilizamos cookies y tecnologías similares para recopilar información sobre su actividad en nuestro sitio web y mejorar su experiencia de navegación.<br>b. Puede gestionar las preferencias de cookies a través de la configuración de su navegador.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data17: {
    es: '<p>Derechos del usuario:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data18: {
    es: '<p>a. Acceso y corrección: Tiene derecho a acceder, corregir o eliminar su información personal. Puede hacerlo a través de su cuenta en nuestro sitio web, poniéndose en contacto con nosotros o a través de la App. Las solicitudes consideradas fraudulentas, excesivas o infundadas podrán no ser atendidas. Podrá establecerse un canon para aquellas solicitudes consideradas excesivas o infundadas. Para atender la solicitud deberás especificarnos:<br>·&emsp;&emsp;Nombre y apellidos del usuario.<br>·&emsp;&emsp;Copia del DNI o documento equivalente a efectos identificativos.<br>·&emsp;&emsp;En los casos en que se admita la representación, serán los datos del representante así como documento acreditativo de la representación.<br>·&emsp;&emsp;Petición con los motivos específicos de la solicitud o información a la que se quiere acceder.<br>·&emsp;&emsp;Domicilio a efecto de notificaciones.<br>·&emsp;&emsp;Fecha y firma del solicitante.<br>·&emsp;&emsp;Todo documento que acredite la petición que formula.<br>Esta solicitud deberá ser enviada a:<br>Dirección postal: Torre Siglo XXI.Paseo Fluvial N15, P11. 06011 Badajoz, España<br>info@smartmakings.com<br>b. Limitación y portabilidad: Tienes derecho a solicitar la restricción temporal de tus Datos personales siempre que sea técnicamente posible podrás solicitar la portabilidad de tus datos mediante un archivo estructurado, de uso común y legible por un sistema informático.<br>Puedes solicitar la limitación o portabilidad de tus datos a través de tu cuenta en nuestro sitio web, poniéndote en contacto con nosotros o a través de la App. Las solicitudes consideradas fraudulentas, excesivas o infundadas podrán no ser atendidas.Podrá establecerse un canon para aquellas solicitudes consideradas excesivas o infundadas. Para atender la solicitud deberás especificarnos:<br>·&emsp;&emsp;Nombre y apellidos del usuario.<br>·&emsp;&emsp;Copia del DNI o documento equivalente a efectos identificativos.<br>·&emsp;&emsp;En los casos en que se admita la representación, serán los datos del representante, así como documento acreditativo de la representación.<br>·&emsp;&emsp;Petición con los motivos específicos de la solicitud o información a la que se quiere acceder.<br>·&emsp;&emsp;Domicilio a efecto de notificaciones.<br>·&emsp;&emsp;Fecha y firma del solicitante.<br>·&emsp;&emsp;Todo documento que acredite la petición que formula.<br>c. Derecho a retirar el consentimiento: Puede retirar su consentimiento para el procesamiento de sus datos personales en cualquier momento.<br>d. Derecho a presentar una queja: Si considera que sus derechos de privacidad se han infringido, tiene derecho a presentar una queja ante la autoridad de protección de datos correspondiente.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data19: {
    es: '<p>Cambios en esta política:</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data20: {
    es: '<p>Esta Política de Privacidad puede actualizarse ocasionalmente de forma unilateral y sin previo aviso. Esta Política de Privacidad fue actualizada para adaptarse al Reglamento (UE) 2016/679 del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos (RGPD) y a la Ley Orgánica 3/2018, de 5 de diciembre, de Protección de Datos Personales y garantía de los derechos digitales. Te informaremos de cualquier cambio importante a través de nuestro sitio web.<br>Es necesario que el usuario haya leído y esté conforme con las condiciones sobre la protección de datos de carácter personal contenidas en esta Política de Privacidad. El uso del sitio web http://smartmakings.com/ implicará la aceptación de la Política de Privacidad.<br>Si tiene alguna pregunta o inquietud sobre esta Política de Privacidad, no dude en ponerse en contacto con nosotros a través de info@smartmakings.com.Su privacidad es importante para nosotros, y haremos todo lo posible para protegerla.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data21: {
    es: '<p>Autorización para el Tratamiento de Datos Personales de Menores en la Aplicación (Smart)Makings </p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data22: {
    es: '<p>En cumplimiento del <span class="i18n-bold">Reglamento (UE) 2016/679</span> del Parlamento Europeo y del Consejo, de 27 de abril de 2016, relativo a la protección de las personas físicas en lo que respecta al tratamiento de datos personales y a la libre circulación de estos datos <span class="i18n-bold">(RGPD)</span>, así como de cualquier otra normativa aplicable en materia de protección de datos, a continuación, se detalla la política de tratamiento de los datos personales de los alumnos menores de edad de los centros educativos participantes en el programa de (Smart)Makings: </p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data23: {
    es: '<p>Responsable del Tratamiento de los Datos Personales</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data24: {
    es: '<p><span class="i18n-bold">(Smart)Makings no actúa como responsable del tratamiento de los datos personales</span> de los alumnos. Los datos personales de los menores son recabados y gestionados por el <span class="i18n-bold">centro educativo</span> correspondiente, que actúa como responsable del tratamiento de los datos conforme al artículo 4.7 del RGPD.<br><br>El tratamiento de los datos personales por parte de(Smart)Makings se realiza en calidad de <span class="i18n-bold">encargado del tratamiento</span>, tal como se describe en el artículo 4.8 del RGPD. Nuestra actividad se limita a proporcionar los servicios necesarios para la identificación de los alumnos y la elaboración de sus informes de resultados, sin que, en ningún caso, adquiramos la propiedad o el control de dichos datos.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data25: {
    es: '<p>Datos Personales Tratados </p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data26: {
    es: '<p>Los datos personales que serán tratados a través de la plataforma de (Smart)Makings son:<br><br><span class="i18n-bold">&emsp;· Nombre completo del alumno.</span><br><br><span class="i18n-bold">&emsp;· Correo electrónico corporativo proporcionado por el centro educativo.</span><br><br>El único propósito de este tratamiento es <span class="i18n-bold">identificar al alumno</span> y enlazar sus respuestas durante el uso de la plataforma con su <span class="i18n-bold">informe de resultados</span>, el cual será entregado al <span class="i18n-bold">centro educativo</span> al final del curso o programa educativo. Dicho informe tiene como finalidad la <span class="i18n-bold">evaluación del progreso educativo</span> de cada alumno y no será utilizado para ningún otro fin.<br><br>(Smart)Makings <span class="i18n-bold">no recaba ni trata directamente otros datos personales</span>, como la dirección, fecha de nacimiento, información académica externa o cualquier otro tipo de información sensible, a menos que se estipule expresamente en acuerdos contractuales.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data27: {
    es: '<p>Base Jurídica del Tratamiento</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data28: {
    es: '<p>El tratamiento de los datos personales de los alumnos menores de edad se lleva a cabo <span class="i18n-bold">sobre la base jurídica del cumplimiento de una misión de interés público</span> o el ejercicio de poderes públicos conferidos al centro educativo (art. 6.1.e RGPD). El centro educativo actúa como el responsable del tratamiento, garantizando que el tratamiento de los datos cumple con los requisitos del RGPD, incluidas las bases jurídicas necesarias, y asegurando la obtención del consentimiento explícito de los padres o tutores legales de los alumnos menores de edad, en los casos donde este sea necesario. </p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data29: {
    es: '<p>Obligaciones del Centro Educativo</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data30: {
    es: '<p>(Smart)Makings no puede garantizar ni es responsable de que los datos proporcionados por el centro educativo en la plataforma sean exactos, verídicos o estén libres de errores. El <span class="i18n-bold">centro educativo</span> es responsable de la correcta incorporación de los datos personales de los alumnos y de garantizar que estos se ajusten a la realidad, así como de obtener cualquier consentimiento parental necesario para el tratamiento de los datos de los menores. <br><br>En caso de error en los datos proporcionados por el centro, (Smart)Makings no asumirá responsabilidad alguna en relación con el tratamiento de datos incorrectos o falsos. Si se detectan errores, el centro educativo deberá notificar de inmediato a(Smart)Makings para proceder a su corrección o eliminación.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data31: {
    es: '<p>Seguridad y Almacenamiento de los Datos </p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data32: {
    es: '<p>(Smart)Makings se compromete a garantizar la <span class="i18n-bold">seguridad en el almacenamiento de los datos personales</span> tratados en el marco de su plataforma. Para ello, se implementan <span class="i18n-bold">medidas técnicas y organizativas</span> adecuadas para la protección de los datos, en cumplimiento con el <span class="i18n-bold">Esquema Nacional de Seguridad (ENS) y el artículo 32 del RGPD.</span><br><br>Los datos personales recabados serán almacenados en servidores ubicados dentro del <span class="i18n-bold">Espacio Económico Europeo(EEE)</span>, específicamente en Europa, lo que garantiza que se cumple con los altos estándares de protección de datos exigidos por la legislación europea. Estos servidores cuentan con las certificaciones y garantías necesarias para cumplir con el <span class="i18n-bold">Esquema Nacional de Seguridad(ENS)</span>, lo que asegura la máxima protección contra accesos no autorizados, pérdida, alteración o cualquier otro tipo de riesgo.<br><br>Además, se emplean tecnologías de <span class="i18n-bold">cifrado y control de acceso restringido</span> para garantizar que solo personal autorizado pueda acceder a los datos, y únicamente con fines legítimos dentro de los servicios prestados por(Smart)Makings.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data33: {
    es: '<p>Duración del Tratamiento de los Datos </p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data34: {
    es: '<p>Los datos personales serán tratados por (Smart)Makings <span class="i18n-bold">únicamente durante el periodo en el que los alumnos participen en el programa educativo</span>proporcionado por la plataforma. Una vez concluido el programa y entregados los informes finales al centro educativo, (Smart)Makings procederá a la <span class="i18n-bold">anonimización</span> de los datos personales en un plazo máximo de 90 días, salvo que exista una obligación legal de conservarlos. </p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data35: {
    es: '<p>Medidas de Seguridad</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data36: {
    es: '<p>(Smart)Makings se compromete a implementar las <span class="i18n-bold">medidas de seguridad técnicas y organizativas adecuadas</span> para garantizar la confidencialidad, integridad y disponibilidad de los datos personales tratados, de conformidad con lo dispuesto en el artículo 32 del RGPD. Esto incluye, entre otras medidas:<br><br><span class="i18n-bold">&emsp;· Cifrado de datos sensibles</span><br><br><span class="i18n-bold">&emsp;· Control de acceso restringido a los datos personales</span><br><br><span class="i18n-bold">&emsp;· Monitorización y auditoría continua de los sistemas de seguridad</span><br><br><span class="i18n-bold">&emsp;· Evaluación periódica de riesgos y políticas de seguridad</span><br><br>(Smart)Makings realiza revisiones constantes para asegurarse de que las medidas implementadas estén actualizadas y sean acordes a los últimos estándares de seguridad.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data37: {
    es: '<p>Derechos de los Interesados</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data38: {
    es: '<p>Los padres, tutores legales o, en su caso, los alumnos, podrán ejercer en cualquier momento los derechos que les otorga el RGPD en relación con el tratamiento de sus datos personales. Estos derechos incluyen:<br><br><span class="i18n-bold">&emsp;· Derecho de acceso:</span> solicitar confirmación sobre si estamos tratando los datos personales y, en tal caso, obtener una copia de dichos datos.<br><br><span class="i18n-bold">&emsp;· Derecho de rectificación:</span> solicitar la corrección de datos inexactos o incompletos.<br><br><span class="i18n-bold">&emsp;· Derecho de supresión:</span> solicitar la eliminación de los datos personales cuando ya no sean necesarios para los fines para los que fueron recogidos.<br><br><span class="i18n-bold">&emsp;· Derecho de limitación del tratamiento:</span> solicitar que se limite el tratamiento de los datos en determinadas circunstancias.<br><br><span class="i18n-bold">&emsp;· Derecho de portabilidad:</span> recibir los datos en un formato estructurado y de uso común, o solicitar que se transfieran a otro responsable, en los casos aplicables.<br><br>Para ejercer estos derechos, el interesado deberá dirigirse al centro educativo responsable del tratamiento, que gestionará las solicitudes en coordinación con(Smart)Makings cuando sea necesario.</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data39: {
    es: '<p>Delegado de Protección de Datos</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
  privacy_Data40: {
    es: '<p>(Smart)Makings ha designado un Delegado de Protección de Datos(DPO), encargado de garantizar el cumplimiento de la normativa vigente. Para cualquier consulta relacionada con la protección de datos, puede ponerse en contacto con nuestro DPO en el siguiente correo electrónico: dpo@smartmakings.com</p>',
    en: '<p></p>',
    pt: '<p></p>',
    fr: '<p></p>',
    eus: '<p></p>',
    cat: '<p></p>',
  },
};
